<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input mb-5">Section Name</label>
          <v-row>
            <v-col cols="12" md="9">
              <div>
                <v-text-field outlined dense v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox dense v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <div class="label-input">Section Settings</div>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields['topPadding']" label="Top Padding" dense hide-details />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" dense hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['text-color']"
                      @change="handleChangeTextColor"
                    />
                    <v-text-field v-model="fields['text-color']" label="Text Color" />
                    <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="head"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['background-color']"
                        @change="handleChangeBackgroundColor"
                      />
                      <v-text-field v-model="fields['background-color']" label="Background Color" />
                      <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <label class="label-input">Main</label>
          <div class="mb-8">
            <UploadImage
              @callback="handleUploadImage"
              :image="{ imageSrc: fields['main-image-satellite'] }"
              :height="`250`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveUpload"
            />
          </div>
          <!-- <v-text-field outlined v-model="fields['main-title-satellite']" label="Main Title" /> -->
          <ckeditor :editor="editor" v-model="fields['main-title-satellite']" :config="editorConfig" />
          <!-- <v-textarea
            outlined
            type="textarea"
            v-model="fields['main-description-satellite']"
            label="Main Description"
          /> -->
        </div>

        <div class="mb-6">
          <DividerPrimary :divider="fields['dividerPrimary']" />
        </div>

        <div>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input">Satellites</label>
            <v-btn small text color="primary" @click="handleAddSatellite">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Satellite</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['items-satellite']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Satellite {{ i + 1 }}</span>
                  <!-- <div class="pr-2 color-red" @click.stop="handleRemoveSatellite(i)">
                    <span>Remove</span>
                  </div> -->
                  <v-btn icon @click.stop="handleRemoveSatellite(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="wrap-product-form">
                  <div class="image-upload mb-7">
                    <label> Image</label>
                    <UploadImage
                      @callback="obj => handleUploadImageSatellite(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUploadSatellite(i)"
                    />
                  </div>
                  <v-text-field outlined v-model="item.title" label="Title" />
                  <v-textarea outlined type="textarea" v-model="item.description" label="Description" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import DividerPrimary from '@/views/website/products/components/description/section-editor/common/divider-primary.vue';
export default {
  name: 'satellite-grid-section-editor',
  components: {
    UploadImage,
    DividerPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'items-satellite': [],
        'satellite-grid-container': '',
        'main-title-satellite': '',
        'main-description-satellite': '',
        'main-image-satellite': '',
        'text-color': '',
        'background-color': '',
        topPadding: true,
        bottomPadding: true,
        dividerPrimary: {
          show: false,
          maxWidth: 200,
          height: 1,
          backgroundColor: '#E0E0E0',
          align: 'center',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj) {
      if (obj && obj.imageSrc) {
        this.fields['main-image-satellite'] = obj.imageSrc;
      }
    },
    handleRemoveUpload() {
      this.fields['main-image-satellite'] = '';
    },
    handleUploadImageSatellite(obj, i) {
      if (obj && obj.imageSrc) {
        this.fields['items-satellite'][i].image = obj.imageSrc;
      }
    },
    handleRemoveUploadSatellite(i) {
      this.fields['items-satellite'][i].image = '';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSatelliteGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddSatellite() {
      this.fields['items-satellite'].push({
        image: '',
        title: '',
        description: '',
      });
    },
    handleRemoveSatellite(i) {
      this.fields['items-satellite'].splice(i, 1);
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
